import { loadStyle } from '@/util/util'
import envConfig from '@/config/env'

import '@/styles/common.scss'
import '@/styles/excel_loading/loading.scss'
import '@/config/icons'

// 动态加载阿里云字体库
envConfig.iconfontVersion.forEach((ele) => {
  loadStyle(envConfig.iconfontUrl.replace('$key', ele))
})
